import { Button, Card, message, Typography } from 'antd';
import SubscriptionSelector from '../../components/SubscriptionSelector';
import { SubscriptionDto } from '../../services/api/types/billing';
import React from 'react';
import FeatureLimitsEdit from '../../components/FeatureLimitsEdit';
import UserSelectorComponent from '../../components/UserSelector';
import { useNavigate } from 'react-router';
import { RouterPaths } from '../../router/paths';
import { useSelector } from 'react-redux';
import { selectUserState } from '../../store/selectors/user';
import { apiFeatureLimitsInitiateResetCheck } from '../../services/api/feature-limits';

function FeatureLimitsEditPage() {
  const { token } = useSelector(selectUserState);
  const [selectedSubscriptionType, setSelectedSubscriptionType] =
    React.useState<SubscriptionDto | null>(null);
  const navigate = useNavigate();

  async function onInitiateUsageResetCheck() {
    if (token) {
      try {
        const [res] = await apiFeatureLimitsInitiateResetCheck(token);
        if (res) {
          message.success('User feature usage reset check finished.');
        } else {
          message.error('User feature usage reset check failed.');
        }
      } catch (e) {
        console.error(e);
        message.error('User feature usage reset check failed.');
      }
    }
  }

  return (
    <Card title="Feature Limits">
      <Typography.Title level={2}>Feature Limits</Typography.Title>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          marginBottom: 24,
        }}
      >
        <Button onClick={onInitiateUsageResetCheck}>
          Initiate usage reset check
        </Button>
      </div>
      <div style={{ marginBottom: 24 }}>
        <SubscriptionSelector
          name="subscriptionType"
          value={selectedSubscriptionType?.type}
          onChange={(type, subscription) => {
            setSelectedSubscriptionType(subscription);
          }}
        />
        <UserSelectorComponent
          onResult={(userId) => {
            navigate(`${RouterPaths.USERS}/${userId}/feature-limits`);
          }}
        />
      </div>
      <div>
        {selectedSubscriptionType ? (
          <FeatureLimitsEdit subscription={selectedSubscriptionType} />
        ) : null}
      </div>
    </Card>
  );
}

export default FeatureLimitsEditPage;
